export default () => {
  let isLoadingComplete = false;

  function loadAll(trigger) {
    if (!trigger) {
      isLoadingComplete = true;

      if (window.iso) {
        window.iso.reloadItems();
        window.iso.arrange({ filter: '*' });
      }

      return;
    }
    loadMore(trigger, () => {
      const nextTrigger = document.querySelector('[data-next-url]');

      loadAll(nextTrigger);
    });
  }
  const container = document.querySelector('.material-selector__list.material-library');

  if (container) {
    const observer = new MutationObserver((mutations) => {
      if (isLoadingComplete && window.iso) {
        window.iso.reloadItems();
        window.iso.arrange();
      }
    });
    
    observer.observe(container, {
      childList: true
    });
  }

  function loadMore(trigger, doneLoading) {
    const nextUrl = trigger.dataset.nextUrl;

    fetch(nextUrl)
      .then(response => {
        return response.text();
      })
      .then(text => {
        const data = JSON.parse(text);
        const container = document.querySelector('.material-selector__list.material-library');
        const template = container.querySelector('.material-selector__color');
        
        data.materials.forEach(material => {
          const copy = template.cloneNode(true);
          
          copy.className = `material-selector__color material-selector__${material.filter.type} material-selector__${material.filter.range.replace(/\s+/g, '-').toLowerCase()} material-selector__${material.filter.tone}`;
          
          copy.querySelector('a').href = material.url;
          copy.querySelector('img').src = material.image;
          copy.querySelector('.material-selector__name').textContent = material.title;
          copy.querySelector('.material-selector__group').textContent = material.filter.range;
          
          container.appendChild(copy);
        });

        if (data.pagination.next_url && data.pagination.next_url !== null) {
          trigger.dataset.nextUrl = data.pagination.next_url;
        } else {
          trigger.remove();
        }

        doneLoading();
      })
      .catch(error => {
        console.error('Error loading more materials:', error);
      });
  }

  document.addEventListener('DOMContentLoaded', () => {
    loadAll(document.querySelector('[data-next-url]'));
  });
}